export default "__VITE_ASSET__CQljct90__"